import React, { Component } from "react";
import Topbar from "../../Layout/Header/Topbar";
import Header from "../../Layout/Header/Header";
import Footer from "../../Layout/Footer/Footer";
import right from "../../../Assets/img/Artwork.svg";
import facebook from "../../../Assets/img/Image 1.png";
import Facebook from "../../Components/Facebook";
import Google from "../../Components/Google";

import { authenticate } from "../../Utils/Utils";
import Registration from "../../Components/Registration/Registration";


class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    if (authenticate()) {
      this.props.history.push('/pre-start');
    }
  }

  render() {
    return (
      <div className="login Register innerBody">
        <Topbar />
        <Header />
        <div className="container">
          <div className="row">
            <div className="col-lg-7 col-md-12 col-12">
              <div className="card mt-3 mb-5">
                <div className="bg-login"></div>
                <div className="card-body">
                  <div className="row justify-content-center pt-6">
                    <div className="col register_form">
                      <div className="login-form pl-4 pr-4">
                        <div className="d-lg-none d-md-block d-block login-right  justify-content-center pb-5">
                          <h3>Register</h3>
                          <h4>to Start your Puzzling Adventure</h4>
                        </div>

                        <Registration />
                        <div className="row pt-4 pb-4 pl-2 pr-2 text-xs-center">
                          <div className="offset-md-1 col-md-5 col-12 mt-2 mb-2 pr-1">
                            <Google />
                          </div>
                          <div className="col-md-6 col-12 mt-2 mb-2 pr-1 pl-1">
                            <span className="btn-inner--icon">
                              <img
                                src={facebook}
                                alt=""
                                className="fb_log_img"
                              />{" "}
                              &nbsp; <Facebook />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                </div>
                <p className="text-center donthave-account">
                  Already a Member? <a href="/login"> Sign In</a>
                </p>
                <div className="bg-login"></div>
              </div>
            </div>

            <div className="col-lg-5 col-md-12 col-12 login-right  justify-content-center text-center pt-5">
              <div className="d-lg-block d-md-none d-none">
                <h3>Register</h3>
                <h4>to Start your Puzzling Adventure</h4>
              </div>

              <br />
              <img src={right} alt="" />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Register;
